import { useContext, useState as classicUseState } from 'react';

import { withStyles } from '@material-ui/core';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import { blue } from '@material-ui/core/colors';

import {
  setDontShowAgainOnBoardingAtUserConfig,
  setStartOnBoardingAtUserConfig,
} from '@store/redux/features/userConfiguration';
import { RootState, useAppDispatch } from '@store/redux/store';

import { EQUIPMENTS_PICKER_SEND_TYPE } from '@store/machines/equipmentsPicker';
import { resetKnownData } from '@store/redux/features/inventory/knownData';
import { useSelector } from 'react-redux';
import { manualAddAdded } from '@services/mixpanel/trackers/ManualAdd';
import { NavigationContext } from '@layout/navigation/navigation';
import {
  BodySelect,
  Bottom,
  BottomButton,
  ButtonRow,
  CheckCircle,
  UncheckCircle,
  WhiteBottomButton,
} from '../components.styles';

import {
  StyledFormControlLabel,
  SubHeader,
  SubText,
  Text,
} from './OnBoardingBody.styles';

const BlueCheckbox = withStyles({
  root: {
    color: blue[300],
    '&$checked': {
      color: blue,
    },
  },
  checked: {},
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

interface OwnProps {
  onClose: () => void;
  send: EQUIPMENTS_PICKER_SEND_TYPE;
}

export const OnBoardingBody = ({ onClose, send }: OwnProps) => {
  const dispatch = useAppDispatch();
  const knownEquipments = useSelector((state: RootState) =>
    Object.entries(state.knownData.knownEquipments),
  );
  const [dontShowAgain, setDontShowAgain] = classicUseState(false);

  const { studioName } = useContext(NavigationContext);

  const onConfirm = () => {
    if (dontShowAgain) {
      dispatch(setDontShowAgainOnBoardingAtUserConfig(true));
      dispatch(setStartOnBoardingAtUserConfig(true));
    }
    onClose();
    send({
      type: 'LAUNCH',
      data: new Map(knownEquipments),
      modalName: 'MASS_EDIT',
    });
    manualAddAdded(studioName, true);
  };
  const onDismiss = () => {
    if (dontShowAgain) {
      dispatch(setDontShowAgainOnBoardingAtUserConfig(true));
      dispatch(setStartOnBoardingAtUserConfig(false));
    }
    dispatch(resetKnownData());
    onClose();
    manualAddAdded(studioName, false);
  };
  return (
    <>
      <BodySelect>
        <SubHeader>
          You’ve just added {knownEquipments.length} new products
        </SubHeader>
        <Text>
          However, to get the most out of BeamON we need more information.
          Serial #, firmware, and sales information are all required for us to
          alert you when there’s something new or pending about your product.
        </Text>
      </BodySelect>
      <Bottom>
        <ButtonRow>
          <StyledFormControlLabel
            control={
              <BlueCheckbox
                icon={<UncheckCircle />}
                checkedIcon={<CheckCircle />}
                name="checked"
              />
            }
            label=""
            onClick={() => {
              setDontShowAgain(!dontShowAgain);
            }}
          />
          <SubText>Don’t show again</SubText>
        </ButtonRow>
        <ButtonRow>
          <WhiteBottomButton onClick={onDismiss}>Dismiss</WhiteBottomButton>
          <BottomButton onClick={onConfirm}>Onboard Now</BottomButton>
        </ButtonRow>
      </Bottom>
    </>
  );
};
